import React, { useEffect, useState } from "react";
import "../login/login.scss";
import axios from "axios";
import url from "../../url.json";
import { withTranslation } from "react-i18next";
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  FormFeedback,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import headers from "../../config/headers";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { tokenReducer } from "../../Redux/Reducers/Token/TokenReducer";
import { IsLegalReducer } from "../../Redux/Reducers/IsLegal/IsLegal";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Box from "@mui/material/Box";
import { ToastContainer, toast } from "react-toastify";
import { Spin, Button, Alert } from "antd";
import { emailReducer } from "../../Redux/Reducers/Email/email";
function Forgot({ t }) {
  const dispatch = useDispatch();
  const [load, setload] = useState(false);
  const [error, setError] = useState();
  const [serverError, setServerError] = useState();
  const [datas, setdatas] = useState();
  const navigate = useNavigate();
  const handleChange = (value) => {
    value.preventDefault();
    setload(true);
    setServerError();
    const data = {
      email: value.target.email.value,
    };
    axios
      .post(url.url + "/mail", data, { headers: headers() })
      .then((res) => {
        toast.success(res.data.data.success);
        dispatch(emailReducer(value.target.email.value));
        setload(false);
        navigate("/createpassword");
        setError();
      })
      .catch((err) => {
        setload(false);
        const res = err.response;
        // Server javob bermadi (internet / CORS / server o'chiq)
        if (!res) {
          setServerError([err.message]);
          toast.error(t("Code sending failed"));
          return;
        }
        if (res.status == 401) {
          window.location = "/";
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          return;
        }
        const body = res.data;
        const errors = body?.errors || body?.data?.errors;
        // Maydon ostida ham ko'rsatish uchun (masalan email noto'g'ri)
        setError(errors);
        // Validatsiya xatolarining barchasi (qaysi maydon bo'lishidan qat'i nazar)
        const fieldMessages =
          errors && typeof errors === "object"
            ? Object.values(errors).flat().filter(Boolean)
            : [];
        const mainMessage =
          body?.error ||
          body?.message ||
          body?.data?.error ||
          body?.data?.message ||
          (typeof body === "string" ? body : "");
        const lines = fieldMessages.length
          ? fieldMessages
          : [mainMessage || `${res.status} ${res.statusText || ""}`.trim()];
        setServerError(lines);
        toast.error(lines[0] || t("Code sending failed"));
      });
  };
  const steps = [t("Enter email"), t("Create a password")];

  return (
    <div className="wrapper">
      <div className="forms_login">
        <div className="titless">{t("Forgot password")}</div>
        <Box sx={{ width: "100%" }}>
          <Stepper activeStep={0} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel className="ll">{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>
        <Form className="forrr" onSubmit={handleChange}>
          <FormGroup>
            <Label className="lab" for="exampleUsername">
              {t("Email")}
            </Label>
            {!error?.email ? (
              <Input
                className="inpp"
                id="exampleUsername"
                name="email"
                placeholder={t("Email")}
                type="email"
              />
            ) : (
              <Input
                className="inpp invalid"
                id="exampleUsername"
                name="email"
                invalid
                placeholder={t("Email")}
                type="email"
              />
            )}
            {error?.email ? (
              <i style={{ color: "red", fontSize: 14 }}>
                {[].concat(error.email).join(" ")}
              </i>
            ) : (
              ""
            )}
          </FormGroup>
          {serverError ? (
            <Alert
              className="mb-3"
              type="error"
              showIcon
              closable
              onClose={() => setServerError()}
              message={t("Code sending failed")}
              description={
                <div style={{ wordBreak: "break-word", fontSize: 13 }}>
                  {serverError.length > 1 ? (
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                      {serverError.map((m, i) => (
                        <li key={i}>{m}</li>
                      ))}
                    </ul>
                  ) : (
                    serverError[0]
                  )}
                </div>
              }
            />
          ) : null}
          <Button
            className="w-100"
            type="primary"
            htmlType="submit"
            loading={load}
          >
            {t("Send code")}
          </Button>
        </Form>
      </div>
    </div>
  );
}
export default withTranslation()(Forgot);
